import React, { useEffect, useState } from "react";

import HeaderBar from "./HeaderBar";
import ProfilePage from "./ProfilePage";
import SignInPage from "./SignInPage";
import * as Static from "./StaticPages";
import Seasons from "./Seasons";
import SeasonAudit from "./SeasonAudit";
import AuditLayout from "./layouts/AuditLayout";
import RepositoryLayout from "./layouts/RepositoryLayout";
import AdministrationLayout from "./layouts/AdministrationLayout";
import FranchiseConfiguration from "./franchiseAdmin/FranchiseConfiguration";
import EligibilityAdministration from "./EligibilityAdministration";
import OnboardingCandidates from "./OnboardingCandidates";
import FranchiseInventory from "./FranchiseInventory";
import Admin from "./Admin";
import FranchiseCalendars from "./FranchiseCalendars";
import ClassAudit from "./ClassAudit";
import CoachCheckinAudit from "./CoachCheckinAudit";
import RuleManagement from "./RuleManagement";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { apiEndpoint } from '../config/api';
import { apiFetch } from '../services/api';

import { Routes, Route, Outlet, Navigate } from "react-router";
import { getAuth, onAuthStateChanged } from "firebase/auth";


import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/icon?family=Material+Icons"
/>;

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);

// Allowed extensions for input file
// const allowedExtensions = ["csv"];
function App(props) {
  const nullUser = { uid: null, displayName: null };
  const [currentUser, setCurrentUser] = useState(nullUser);
  const [comcodeData, setComCodeData] = useState([]);
  const [seasonDataForQueries, setSeasonDataForQueries] = useState([]);
  const [comcodesError, setComcodesError] = useState(false);
  // Franchise picker source for Season Sequence stewardship: the union of current LK/SI
  // franchises AND any franchise that still has Franchise Calendar buckets (incl. ones the
  // Dash isLilKickerClient flag has since turned off). getComCodes/comcodeData is unchanged.
  const [seasonSequenceFranchises, setSeasonSequenceFranchises] = useState([]);

  useEffect(() => {
    const auth = getAuth();

    onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        //is defined, so "logged in"
        // console.log("authentication state changed");
        // console.log(firebaseUser);
        //add in the keys for the terms we want to use
        firebaseUser.userId = firebaseUser.uid;
        firebaseUser.userName = firebaseUser.displayName;
        setCurrentUser(firebaseUser);
      } else {
        //not defined, so logged out
        setCurrentUser(nullUser);
      }
    });
  }, []); //array is list of variables that will cause this to rerun if changed

  const loginUser = (userObject) => {
    //can do more checking here if we want
    setCurrentUser(userObject);
  };


  //effects to run once the user is authenticated
  useEffect(() => {
    if (!currentUser.uid) return;

    const tempfunction = async () => {
      updateComcodes();
      updateSeasonSequenceFranchises();
      await updateSeasonDatesForQueries();
    }

    tempfunction();

  }, [currentUser.uid]);

  const handleUpdateLocationDimFacility = (facilityLocationData) => {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify({
        dim_facilityID: facilityLocationData.dim_facilityID,
        locationLKSINotes: facilityLocationData.locationLKSINotes,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    };

    apiFetch(`${apiEndpoint}/facility-notes`, requestOptions)
      .then((response) => response.json())
      .then(() => {
        updateComcodes();
      })
      .catch((err) => {
      });
  };


  const updateComcodes = () => {
    apiFetch(`${apiEndpoint}/comcodes/`)
      .then((response) => response.json())
      .then((actualData) => {
        setComCodeData(actualData.transformed.map((comCodeObj) => ({ ...comCodeObj })));
      })
      .catch(() => {
        setComcodesError(true);
      });
  };

  // Season Sequence stewardship picker source (see state comment above). Additive to
  // getComCodes; on failure the Season Sequence route falls back to comcodeData.
  const updateSeasonSequenceFranchises = () => {
    apiFetch(`${apiEndpoint}/season-sequence-franchises/`)
      .then((response) => response.json())
      .then((actualData) => {
        setSeasonSequenceFranchises(actualData.transformed ?? []);
      })
      .catch((err) => {
        setSeasonSequenceFranchises([]);
      });
  };

  const updateSeasonDatesForQueries = async () => {
    return new Promise(async function (resolve, reject) {
      const startDateRange = new Date("2017-01-01");
      const startDateRangeConvert = startDateRange.toISOString().split("T");
      const startDateRangeString = startDateRangeConvert[0];
      // console.log("startDateRangeString", startDateRangeString);

      let endDateRange = new Date();
      endDateRange.setDate(endDateRange.getDate() + 100);
      const endDateRangeConvert = endDateRange.toISOString().split("T");
      const endDateRangeString = endDateRangeConvert[0];

      // console.log("endDateRangeString: ", endDateRangeString);

      let removeSpecialCharsSeasonName = "";
      let removeSpecialCharsFacilityName = "";

      // console.log("updateSeasonDatesForQueries() within App");

      apiFetch(
        `${apiEndpoint}/savedseasons-daterange/${startDateRangeString}/${endDateRangeString}`
      )
        .then((response) => response.json())

        .then((actualData) => {
          // throw new Error("Thrown from the fetch()");

          const transformedData = actualData.data.map((seasonObj) => {
          const dateSeasonStartStringS = seasonObj.seasondates;
          const dateS = new Date(dateSeasonStartStringS);
          const justTheDateS = isNaN(dateS.getTime())
            ? ""
            : dateS.toISOString().split("T")[0];

          const dateSeasonStartStringE = seasonObj.seasondatee;
          const dateE = new Date(dateSeasonStartStringE);
          const justTheDateE = isNaN(dateE.getTime())
            ? ""
            : dateE.toISOString().split("T")[0];

          const seasonTrack = seasonObj.trackingseason;
          const yearTrack = seasonObj.trackingyear;
          const comID = seasonObj.comid;

          removeSpecialCharsSeasonName = (seasonObj.seasonname || "").replace(
            /[^a-zA-Z0-9 ]/g,
            ""
          );

          removeSpecialCharsFacilityName = (seasonObj.facilityname || "").replace(
            /[^a-zA-Z0-9 ]/g,
            ""
          );

          const transformed = {
            ...seasonObj,
            // existing normalized fields
            seasonDateS: justTheDateS,
            seasonDateE: justTheDateE,
            seasonName: removeSpecialCharsSeasonName,
            facilityName: removeSpecialCharsFacilityName,
            trackingSeason: seasonTrack?.toString?.() ?? "",
            trackingYear: yearTrack?.toString?.() ?? "",
            comID: comID?.toString?.() ?? "",
            // camelCase/PascalCase aliases expected by SeasonRow and SeasonList
            sKey: seasonObj.skey ?? "",
            comCode: seasonObj.com_code ?? "",
            seasonID: seasonObj.seasonid ?? null,
            seasonDesc: seasonObj.seasondesc ?? "",
            priorYearSeasonId: seasonObj.prioryearseasonid ?? null,
            priorYearSeasonName: seasonObj.prioryearseasonname ?? "",
            priorSeasonId: seasonObj.priorseasonid ?? null,
            priorSeasonName: seasonObj.priorseasonname ?? "",
            ProgramType: seasonObj.programtype ?? null,
            TrackingSeason: seasonTrack?.toString?.() ?? "",
            TrackingYear: yearTrack?.toString?.() ?? "",
          };
            return transformed;
          });
          setSeasonDataForQueries(transformedData);
          resolve("success");
        })
        .catch(function (e) {
          console.log(
            "updateSeasonDatesForQueries call failed with the following error e:  ",
            e
          );
          reject("failure");
        });
    });
  };


  return (
    <div className="container-fluid d-flex flex-column">
      <Routes>
        <Route
          element={
            <AppLayout currentUser={currentUser} loginUser={loginUser} />
          }
        >
          {/* protected routes */}
          <Route element={<ProtectedPage currentUser={currentUser} />}>
            {/* Audit workflow -- Season Audit is the group INDEX, so it is reachable with no extra
                click and is the authenticated landing target (see the index route below). */}
            <Route path="audit" element={<AuditLayout />}>
              <Route
                index
                element={
                  <SeasonAudit
                    currentUser={currentUser}
                    comcodes={comcodeData}
                    seasonDataForQueries={seasonDataForQueries}
                    handleUpdateLocationDimFacility={handleUpdateLocationDimFacility}
                    updateComcodes={updateComcodes}
                  />
                }
              />
              <Route
                path="class-audit"
                element={
                  <ClassAudit
                    comcodes={seasonSequenceFranchises.length ? seasonSequenceFranchises : comcodeData}
                  />
                }
              />
              {/* Coach Check-In Audit — Identity Review (doc 107, slice 1). Takes no props: the
                  population is the provisional coach identities the warehouse derives, not a
                  franchise list this component is handed. */}
              <Route path="coach-checkin-audit" element={<CoachCheckinAudit />} />
              <Route path="rule-management" element={<RuleManagement />} />
            </Route>

            {/* Repository workflow -- Seasons and Franchise Calendars are peers on the
                operational-season pipeline. */}
            <Route path="repository" element={<RepositoryLayout />}>
              <Route index element={<Navigate to="/repository/seasons" replace />} />
              <Route
                path="seasons"
                element={
                  <Seasons
                    currentUser={currentUser}
                    comcodes={comcodeData}
                    seasonDataForQueries={seasonDataForQueries}
                  />
                }
              />
              <Route
                path="franchise-calendars"
                element={
                  <FranchiseCalendars
                    comcodes={seasonSequenceFranchises.length ? seasonSequenceFranchises : comcodeData}
                  />
                }
              />
            </Route>

            {/* Application Administration + personal settings stay top-level for now. */}
            <Route path="admin" element={<Admin />} />
            <Route
              path="profile"
              element={<ProfilePage currentUser={currentUser} />}
            />

            {/* Administration workflow. The layout owns the section header + area tabs; the feature
                components own their grids/dialogs/data. Areas and lenses live in the path so each is
                deep-linkable and the browser Back button works. */}
            <Route path="administration" element={<AdministrationLayout />}>
              <Route index element={<Navigate to="/administration/franchise" replace />} />
              <Route
                path="franchise"
                element={
                  <FranchiseConfiguration
                    comcodes={comcodeData}
                    updateComcodes={updateComcodes}
                    comcodesError={comcodesError}
                  />
                }
              />
              <Route
                path="franchise/:lens"
                element={
                  <FranchiseConfiguration
                    comcodes={comcodeData}
                    updateComcodes={updateComcodes}
                    comcodesError={comcodesError}
                  />
                }
              />
              <Route path="eligibility" element={<EligibilityAdministration />} />
              <Route path="onboarding" element={<OnboardingCandidates />} />
              <Route path="inventory" element={<FranchiseInventory />} />
            </Route>

            {/* Back-compat: old ComCodes / Franchise Administration paths keep working. */}
            <Route path="franchise-admin" element={<Navigate to="/administration/franchise" replace />} />
            <Route path="franchise-admin/facilities" element={<Navigate to="/administration/franchise/facilities" replace />} />
            <Route path="franchise-admin/eligibility" element={<Navigate to="/administration/eligibility" replace />} />
            <Route path="comcodes" element={<Navigate to="/administration/franchise" replace />} />

            {/* Back-compat: old flat paths keep working via redirect to their new workflow home. */}
            <Route path="seasons" element={<Navigate to="/repository/seasons" replace />} />
            <Route path="season-sequence" element={<Navigate to="/repository/franchise-calendars" replace />} />
            <Route path="class-audit" element={<Navigate to="/audit/class-audit" replace />} />
          </Route>

          {/* public routes */}
          <Route
            path="signin"
            element={
              <SignInPage currentUser={currentUser} loginFunction={loginUser} />
            }
          />
          {/* index is shortcut for path="/" */}
          <Route path="about" element={<Static.AboutPage />} />
          <Route path="*" element={<Static.ErrorPage />} />
        </Route>

        {/* Authenticated users land on Season Audit; signed-out users keep the welcome splash. */}
        <Route
          index
          element={
            currentUser.uid ? (
              <Navigate to="/audit" replace />
            ) : (
              <Static.WelcomePage currentUser={currentUser} />
            )
          }
        />
      </Routes>
    </div>
  );
}

function AppLayout({ currentUser, loginUser }) {
  return (
    <>
      <HeaderBar currentUser={currentUser} loginFunction={loginUser} />
      {/* the nested route */}
      <Outlet />
    </>
  );
}

function ProtectedPage(props) {
  //...determine if user is logged in
  // console.log(props.currentUser);
  if (!props.currentUser.uid) {
    //if no user, send to sign in
    return <Navigate to="/signin" />;
  } else {
    //otherwise, show the child route content
    return <Outlet />;
  }
}
export default App;
